/**
 * Confirmation shown when the user leaves the editor (Home button). Reminds them that
 * exiting saves their work but does not publish it, and that only published rooms are
 * shareable. Presentational only — the parent owns navigation.
 */
export default function ExitEditorModal({ onConfirm, onCancel }) {
  return (
    <div
      onClick={onCancel}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000001,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "80vw",
          maxWidth: "460px",
          background: "white",
          border: "3px solid #000000",
          padding: "28px 30px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          textAlign: "center",
          fontFamily: "DM Mono, monospace",
        }}
      >
        <p style={{ fontSize: "26px", margin: 0 }}>Exit editor?</p>

        <div style={{ marginTop: "16px", fontSize: "15px", lineHeight: 1.6 }}>
          <p style={{ margin: 0 }}>Your work will be saved, but not published.</p>
          <p style={{ margin: 0 }}>Only published rooms can be shared.</p>
        </div>

        <div
          style={{
            marginTop: "24px",
            display: "flex",
            gap: "12px",
            justifyContent: "space-between",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: "10px 12px",
              backgroundColor: "#26EF96",
              color: "black",
              border: "none",
              cursor: "pointer",
              fontFamily: "DM Mono, monospace",
              fontSize: "15px",
              fontWeight: 500,
            }}
          >
            Keep editing
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: "10px 12px",
              background: "white",
              border: "3px solid #000000",
              cursor: "pointer",
              fontFamily: "DM Mono, monospace",
              fontSize: "15px",
              fontWeight: 500,
            }}
          >
            Exit editor
          </button>
        </div>
      </div>
    </div>
  );
}
